module.exports = __webpack_public_path__ + "img/doc-redesigned.9ea0eb3f.svg";